// components/FilteredTimeline.js
//
// Multi-kalender (PropertyTimeline) met bovenaan de woningfilter: zoekbalk met
// dropdown (alle woningen alfabetisch, aan/uit), "Alles toevoegen"/"Alles
// verwijderen" en pillen. Gebruikt in het beheerpaneel.
import React from 'react';
import PropertyTimeline from './PropertyTimeline';
import PropertyFilter, { usePropertySelection, useStableList } from './PropertyFilter';

function FilteredTimeline({ properties, userRole, onEditCleaning, storageKey, initialIds, showOwner }) {
  const stable = useStableList(properties);
  const { selected, setSelected, selectedProperties } = usePropertySelection(
    storageKey || null,
    stable,
    false,
    initialIds || null
  );

  return (
    <>
      <PropertyFilter properties={stable} selected={selected} onChange={setSelected} showOwner={showOwner} />
      <PropertyTimeline properties={selectedProperties} userRole={userRole} onEditCleaning={onEditCleaning} />
    </>
  );
}

export default FilteredTimeline;
